import { Ring } from '@blocks/Loading'
import { useConfigContext } from '@contexts/config'
import { useSidepanelContext } from '@contexts/sidepanel'
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js'
import React, { useCallback } from 'react'
import styled from 'styled-components'

// COMPONENTS
const PayPal = ({ promo, salon }: PayPalProps) => {
    const config = useConfigContext()
    const sidepanel = useSidepanelContext()

    const handleApprove = useCallback(async (data: any) => {
        await salon.actions.payment.capture(data.orderID, promo?.code)
        sidepanel.close()
    }, [promo?.found === true])

    const handleCreateOrder = useCallback(() => salon.api.payment.order(promo?.code).then(response => response.id), [promo?.found === true])

    const Buttons = useCallback(() => {
        return (
            <PayPalButtons 
                createOrder={handleCreateOrder}
                onApprove={handleApprove}
                style={{ shape: "pill", tagline: false, height: 54, layout: "horizontal" }} />
        )
    }, [handleCreateOrder])

    if (!config.paypal_id)
        return null

    return (
        <PayPalScriptProvider options={{ "client-id": config.paypal_id, currency: "EUR" }}>
            <PayPalStyles>
                <PayPalAbsoluteButtons />
                <Buttons />
            </PayPalStyles>
        </PayPalScriptProvider>
    )
}

export default React.memo(PayPal)

/**
 * This component should mimic the actual paypal buttons, 
 * because while rerendering they disapper at a moment.
 */
 const PayPalAbsoluteButtons = () => {
    return (
        <PayPalMimicWrapper>
            <Ring />
            <PayPalMimicButton background="#ffc439" />
        </PayPalMimicWrapper>
    )
}

// STYLES
const PayPalStyles = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 54px;

    & > div {
        width: 100%;
    }
`

const PayPalMimicWrapper = styled.div`
    position: absolute;
    top: -1px;
    left: 0;
    width: 100%;
    height: 100%;

    & > div:first-child {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: not-allowed;
    }
`

const PayPalMimicButton = styled.div<{ background: string, mgb?: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 54px;
    border-radius: 27px;
    background: ${({ background }) => background};
    margin-bottom: ${({ mgb }) => mgb ?? "0px"};
    cursor: not-allowed;
`

interface PayPalProps {
    salon: Customer.Models.Salon.Stateful
    promo: Customer.States.Promo | undefined
}